"use client";
import * as React from "react";
const SvgFileUploadRound = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 14 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M2.73 6.36H4.2v4.82c0 .53.41.96.92.96h3.72c.5 0 .93-.43.93-.96V6.36h1.47c.83 0 1.25-1.04.66-1.65L7.65.28a.9.9 0 0 0-1.31 0L2.08 4.71c-.58.6-.18 1.65.65 1.65M.5 15.04c0 .53.42.96.93.96h11.14c.51 0 .93-.43.93-.96s-.42-.97-.93-.97H1.43a.95.95 0 0 0-.93.97" }));
export {
  SvgFileUploadRound as default
};
